<div class="bcg-card" data-test="color-card-background">
  <span>Card background</span><br />
  <span>Normal text</span> <span class="muted">Muted Text</span> <span class="accent">Accent Text</span>
  <span class="error">Error Text</span>
</div>
<div class="bcg-lighter" data-test="color-lighter-background">
  Lighter background<br />
  Normal text <span class="muted">Muted Text</span> <span class="accent">Accent Text</span> <span
  class="error">Error Text</span>
</div>
<div class="bcg-darker" data-test="color-darker-background">
  Darker background<br />
  Normal text <span class="muted">Muted Text</span> <span class="accent">Accent Text</span> <span
  class="error">Error Text</span>
</div>
<div class="bcg-accent" data-test="color-accent-background">
  <span>Accent background</span><br />
  <span>Normal text</span> <span class="muted">Muted Text</span> <span class="accent">Accent Text</span>
  <span class="error">Error Text</span>
</div>
